import {
  CREATE_MEDIA_ALL_INFO_PATIENT_FAIL,
  CREATE_MEDIA_ALL_INFO_PATIENT_REQUEST,
  CREATE_MEDIA_ALL_INFO_PATIENT_SUCCESS,
  CREATE_MEDIA_INFORMATION_FAIL,
  CREATE_MEDIA_INFORMATION_REQUEST,
  CREATE_MEDIA_INFORMATION_SUCCESS,
} from "../../ActionType/MediaInformationType/MediaInformation";

export const createMediaInformationReducer = (
  state = { loading: false, data: [], total: 0, error: "" },
  action
) => {
  switch (action.type) {
    case CREATE_MEDIA_INFORMATION_REQUEST:
      return {
        loading: true,
      };
    case CREATE_MEDIA_INFORMATION_SUCCESS:
      return {
        loading: false,
        data: action.payload,

        error: "",
      };
    case CREATE_MEDIA_INFORMATION_FAIL:
      return {
        loading: false,
        data: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const createMediaAllInformationReducer = (
  state = { loading: false, allInfo: [], total: 0, error: "" },
  action
) => {
  switch (action.type) {
    case CREATE_MEDIA_ALL_INFO_PATIENT_REQUEST:
      return {
        loading: true,
      };
    case CREATE_MEDIA_ALL_INFO_PATIENT_SUCCESS:
      return {
        loading: false,
        allInfo: action.payload,
        error: "",
      };
    case CREATE_MEDIA_ALL_INFO_PATIENT_FAIL:
      return {
        loading: false,
        allInfo: [],
        error: action.error,
      };
    default:
      return state;
  }
};
